"use strict";
'use client';
var __spreadArray = (this && this.__spreadArray) || function (to, from, pack) {
    if (pack || arguments.length === 2) for (var i = 0, l = from.length, ar; i < l; i++) {
        if (ar || !(i in from)) {
            if (!ar) ar = Array.prototype.slice.call(from, 0, i);
            ar[i] = from[i];
        }
    }
    return to.concat(ar || Array.prototype.slice.call(from));
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.useBonusesCards = void 0;
var profile_api_1 = require("@l2p/profile-api");
var swr_hooks_1 = require("@l2p/swr-hooks");
var navigation_1 = require("next/navigation");
var react_1 = require("react");
var useBonusesCards = function () {
    var router = (0, navigation_1.useRouter)();
    var _a = (0, swr_hooks_1.useBalance)(), data = _a.data, isLoadingBalance = _a.isLoading, isValidatingBalance = _a.isValidating;
    var _b = (0, swr_hooks_1.useBonuses)(data === null || data === void 0 ? void 0 : data.currency), bonuses = _b.data, isBonusesLoading = _b.isLoading, isBonusesValidation = _b.isValidating;
    var _c = (0, react_1.useState)(null), bonusToCancel = _c[0], setBonusToCancel = _c[1];
    var _d = (0, react_1.useState)(null), bonusToActivate = _d[0], setBonusToActivate = _d[1];
    var _e = (0, react_1.useState)(null), bonusToDirectActivation = _e[0], setBonusToDirectActivation = _e[1];
    var cancelBonusHandler = (0, react_1.useCallback)(function (bonus) {
        setBonusToCancel(bonus);
    }, []);
    var closeCancelBonusModal = (0, react_1.useCallback)(function () {
        setBonusToCancel(null);
    }, []);
    var _f = (0, swr_hooks_1.useCancelBonus)({
        successAction: function () {
            closeCancelBonusModal();
            router.refresh();
        },
    }), cancelBonus = _f.cancelBonus, isCancelingBonus = _f.isSubmitting;
    var _g = (0, swr_hooks_1.useActivateBonus)({
        successAction: function () {
            closeActivateBonusModal();
            setBonusToDirectActivation(null);
            router.refresh();
        },
    }), activateBonus = _g.activateBonus, isActivateSubmitting = _g.isSubmitting;
    var confirmCancelBonus = (0, react_1.useCallback)(function () {
        if (bonusToCancel === null || bonusToCancel === void 0 ? void 0 : bonusToCancel.id) {
            cancelBonus({ bonusId: bonusToCancel.id });
        }
    }, [bonusToCancel, cancelBonus]);
    var closeActivateBonusModal = (0, react_1.useCallback)(function () {
        setBonusToActivate(null);
    }, []);
    var confirmActivateBonus = (0, react_1.useCallback)(function (bonus) {
        if (bonusToActivate === null || bonusToActivate === void 0 ? void 0 : bonusToActivate.id) {
            activateBonus({ bonusId: bonusToActivate.id });
        }
        else if (bonus === null || bonus === void 0 ? void 0 : bonus.id) {
            activateBonus({ bonusId: bonus.id });
            setBonusToDirectActivation(bonus);
        }
    }, [setBonusToDirectActivation, bonusToActivate, activateBonus]);
    var sortedBonuses = (0, react_1.useMemo)(function () {
        if (!bonuses)
            return [];
        var activeBonus = bonuses.find(function (bonus) { return bonus.status === profile_api_1.BonusCardStatus.InProgress; });
        var pendingBonuses = bonuses.filter(function (bonus) { return bonus.status === profile_api_1.BonusCardStatus.Pending; });
        if (activeBonus)
            return __spreadArray([activeBonus], pendingBonuses, true);
        return pendingBonuses;
    }, [bonuses]);
    var activateBonusHandler = (0, react_1.useCallback)(function (bonus) {
        if (!bonus)
            return;
        if ((data === null || data === void 0 ? void 0 : data.amount) &&
            (data === null || data === void 0 ? void 0 : data.totalAmount) &&
            Number(data.totalAmount) > Number(data.amount))
            setBonusToActivate(bonus);
        else if ((data === null || data === void 0 ? void 0 : data.amount) && (data === null || data === void 0 ? void 0 : data.totalAmount)) {
            confirmActivateBonus(bonus);
        }
    }, [setBonusToActivate, data === null || data === void 0 ? void 0 : data.amount, data === null || data === void 0 ? void 0 : data.totalAmount, confirmActivateBonus]);
    return (0, react_1.useMemo)(function () { return ({
        sortedBonuses: sortedBonuses,
        cancelBonusHandler: cancelBonusHandler,
        closeCancelBonusModal: closeCancelBonusModal,
        confirmCancelBonus: confirmCancelBonus,
        isCancelingBonus: isCancelingBonus,
        closeActivateBonusModal: closeActivateBonusModal,
        isActivateSubmitting: isActivateSubmitting,
        confirmActivateBonus: confirmActivateBonus,
        activateBonusHandler: activateBonusHandler,
        bonusToCancel: bonusToCancel,
        bonusToActivate: bonusToActivate,
        bonusToDirectActivation: bonusToDirectActivation,
        isLoading: isLoadingBalance || isBonusesLoading,
        isValidation: isValidatingBalance || isBonusesValidation,
    }); }, [
        sortedBonuses,
        cancelBonusHandler,
        closeCancelBonusModal,
        confirmCancelBonus,
        isCancelingBonus,
        closeActivateBonusModal,
        isActivateSubmitting,
        confirmActivateBonus,
        activateBonusHandler,
        bonusToCancel,
        bonusToActivate,
        bonusToDirectActivation,
        isLoadingBalance,
        isBonusesLoading,
        isValidatingBalance,
        isBonusesValidation,
    ]);
};
exports.useBonusesCards = useBonusesCards;
